"use strict";
/**
 * Shared constants for HVP2021
 * Re-exports from constants/index.ts for backward compatibility.
 *
 * Note: This file exists for module resolution. TypeScript resolves
 * `import from './constants'` to this file instead of constants/index.ts.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UMA_2024_DAILY = exports.VERSION = exports.APP_NAME = void 0;
// Application Constants (kept here for backward compatibility)
exports.APP_NAME = 'HVP2021';
exports.VERSION = '1.0.0';
exports.UMA_2024_DAILY = 108.57;
// Re-export everything from constants folder
__exportStar(require("./constants/index"), exports);
